import React, { useState } from 'react';
import RegularEndingsTab from './RegularEndingsTab';
import StaticEndingsTab from './StaticEndingsTab';
import ContextEndingTab from './ContextEndingTab';
import './InteractiveSceneEndings.css';

const InteractiveSceneEndings = ({
  novelId,
  sceneId,
  scene,
  setScene,
  novel,
  loading,
  setLoading,
  error,
  setError,
  isProduction = false,
  sceneType = 'interactive'
}) => {
  const [activeTab, setActiveTab] = useState('regular');

  const sharedProps = { novelId, sceneId, scene, setScene, novel, loading, setLoading, setError, isProduction, sceneType };

  return (
    <div className="isend-wrap">
      <div className="isend-header">
        <h3>Концовки сцены</h3>
        <p className="isend-help">Настройте различные способы завершения этой интерактивной сцены и что происходит дальше</p>
      </div>

      <div className="isend-tabs">
        <button
          className={`isend-tab ${activeTab === 'regular' ? 'active' : ''}`}
          onClick={() => setActiveTab('regular')}
        >
          Автоматические концовки
        </button>
        <button
          className={`isend-tab ${activeTab === 'static' ? 'active' : ''}`}
          onClick={() => setActiveTab('static')}
        >
          Концовки-выборы
        </button>
        {sceneType !== 'open_world' && (
          <button
            className={`isend-tab ${activeTab === 'context' ? 'active' : ''}`}
            onClick={() => setActiveTab('context')}
          >
            Контекстная концовка
          </button>
        )}
      </div>

      {error && <div className="isend-error">{error}</div>}

      {activeTab === 'regular' && <RegularEndingsTab {...sharedProps} />}
      {activeTab === 'static' && <StaticEndingsTab {...sharedProps} />}
      {activeTab === 'context' && sceneType !== 'open_world' && <ContextEndingTab {...sharedProps} />}
    </div>
  );
};

export default InteractiveSceneEndings;
